import React, { useState } from "react";
import { Search } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

// Step 2: tick stage managers; when productions exist, choose which ones each covers.
export default function StageManagersStep({ status, picks, setPicks }) {
  const [q, setQ] = useState("");
  const productions = status.productions || [];
  const members = (status.members || []).filter((m) => m.name.toLowerCase().includes(q.trim().toLowerCase()));
  const toggleMember = (id, on) => setPicks((p) => {
    const next = { ...p };
    if (on) next[id] = []; else delete next[id];
    return next;
  });
  const toggleProd = (id, pid) => setPicks((p) => ({ ...p, [id]: p[id].includes(pid) ? p[id].filter((x) => x !== pid) : [...p[id], pid] }));

  return (
    <div data-testid="theatre-setup-stage-managers">
      <p className="mb-3 text-sm text-slate-500">
        Ticked members join <span className="font-semibold text-slate-700">{status.stage_manager_group?.name}</span>.
        {productions.length ? " Choose the productions each one manages so they appear on that production's Manager line." : " Create productions in Team Members → Groups later and add your stage managers to them."}
      </p>
      <div className="relative mb-3">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members" className="pl-9" data-testid="theatre-setup-search" />
      </div>
      <div className="max-h-[22rem] space-y-2 overflow-y-auto pr-1">
        {!members.length && <p className="py-6 text-center text-sm text-slate-400" data-testid="theatre-setup-no-members">No members found.</p>}
        {members.map((m) => {
          const on = m.id in picks;
          return (
            <div key={m.id} className={`rounded-lg border px-4 py-3 transition-colors ${on ? "border-rose-200 bg-rose-50/50" : "border-slate-200 bg-white"}`} data-testid={`theatre-setup-member-${m.id}`}>
              <label className="flex cursor-pointer items-center gap-3">
                <Checkbox checked={on} onCheckedChange={(v) => toggleMember(m.id, !!v)} data-testid={`theatre-setup-member-check-${m.id}`} />
                <span className="text-sm font-medium text-slate-800">{m.name}</span>
              </label>
              {on && productions.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1.5 pl-7">
                  {productions.map((p) => {
                    const sel = picks[m.id].includes(p.id);
                    return (
                      <button key={p.id} type="button" onClick={() => toggleProd(m.id, p.id)} data-testid={`theatre-setup-prod-${m.id}-${p.id}`}
                        className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${sel ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`}>
                        {p.name}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
